module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"category_view_suffix":", обзор"},"en":{"category_view_suffix":", overview"}}')
  delete Component.options._Ctor
}
